import { Typography } from "@mui/material";
import type { DateTimeString } from "../api/types";

export type DateTimeDisplayProps = {
  date?: DateTimeString;
  /**
   * Allow a break between the date and the time. Off by default — most call
   * sites want the stamp on one line — but a narrow table column needs the
   * 113px one-liner to fold in two.
   */
  wrap?: boolean;
};

const pad = (n: number) => n.toString().padStart(2, "0");

const formatDateTime = (date?: DateTimeString): string => {
  if (!date) return "-";
  const d = new Date(date);
  if (isNaN(d.getTime())) return date;
  const ymd = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  return `${ymd} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const DateTimeDisplay = ({ date, wrap }: DateTimeDisplayProps) => (
  <Typography
    variant="body2"
    className="datetime-display"
    component="span"
    sx={{
      color: "text.secondary",
      whiteSpace: wrap ? "normal" : "nowrap",
    }}
  >
    {formatDateTime(date)}
  </Typography>
);
